import dayjs from "dayjs";
import "dayjs/locale/pt.js";
import customParseFormat from "dayjs/plugin/customParseFormat.js";
import duration from "dayjs/plugin/duration.js";
import objectSupport from "dayjs/plugin/objectSupport.js";
import relativeTime from "dayjs/plugin/relativeTime.js";
import timezone from "dayjs/plugin/timezone.js";
import utc from "dayjs/plugin/utc.js";

dayjs.locale("pt");
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(objectSupport);
dayjs.extend(customParseFormat);
// dayjs.tz.setDefault("America/Sao_Paulo");

export const Dayjs = dayjs;
